import { SetStateAction, Dispatch, createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface SearchOpenContext {
  headerSearchMenuOpen: boolean;
  setHeaderSearchMenuOpen: Dispatch<SetStateAction<boolean>>;
  mobileSearchMenuOpen: boolean;
  setMobileSearchMenuOpen: Dispatch<SetStateAction<boolean>>;
}

const ctx = createContext<SearchOpenContext>({} as SearchOpenContext);
export const SearchContextProvider = ctx.Provider;

export function useSearchOpenContextBuilder(): SearchOpenContext {
  const [isHeaderSearchMenuOpen, setIsHeaderSearchMenuOpen] = useState(false);
  const [isMobileSearchMenuOpen, setIsMobileSearchMenuOpen] = useState(false);

  const path = useLocation().pathname;

  useEffect(() => {
    setIsHeaderSearchMenuOpen(false);
    setIsMobileSearchMenuOpen(false);
  }, [path]);

  return {
    headerSearchMenuOpen: isHeaderSearchMenuOpen,
    setHeaderSearchMenuOpen: setIsHeaderSearchMenuOpen,
    mobileSearchMenuOpen: isMobileSearchMenuOpen,
    setMobileSearchMenuOpen: setIsMobileSearchMenuOpen,
  };
}

export function useSearchOpenContext() {
  return useContext(ctx);
}
